<!-- track alto: gera o scroll que vira deslocamento horizontal -->
<section class="gallery" id="produtos">
  <div class="gallery-sticky" #viewport>
    <!-- Paisagem 3D fixa como fundo (mesma cena do início, sem iglu) -->
    <app-igloo-hero mode="landscape" class="gallery-landscape"></app-igloo-hero>

    <div class="gallery-head">
      <p class="gallery-kicker">////// O que entregamos</p>
      <h2 class="gallery-heading">Nossos <span class="hl">produtos</span></h2>
    </div>

    <div class="gallery-track" #track>
      <article class="panel" *ngFor="let p of products">
        <span class="panel-num">{{ p.n }}</span>
        <div class="panel-body">
          <h3 class="panel-title">{{ p.title }}</h3>
          <p class="panel-desc">{{ p.desc }}</p>
        </div>
        <a class="panel-cta" [routerLink]="['/servicos']" [fragment]="p.fragment">Ver mais &rarr;</a>
      </article>
    </div>

    <p class="gallery-hint">role para explorar &rarr;</p>

    <!-- Véu branco: começa cobrindo (continua a nevasca) e abre ao entrar na galeria -->
    <div class="gallery-fade" #fade></div>
  </div>
</section>
